export const CASE_STATUSES = {
    UNSET: "UNSET",
    OPEN: "OPEN",
    CLOSED: "CLOSED",
    PENDING: "PENDING",
};
export const CASE_STATUS_META = {
    UNSET: { label: "------", backgroundColour: "#E9ECEF", colour: "#495057" },
    OPEN: { label: "Open", backgroundColour: "#DFF4D8", colour: "#2F6B1F" },
    CLOSED: { label: "Closed", backgroundColour: "#F1F3F5", colour: "#495057" },
    PENDING: { label: "Pending", backgroundColour: "#FFF3CD", colour: "#7A4E00" },
};
export const CASE_STATUS_LABELS = Object.values(CASE_STATUS_META).map((s) => s.label);
export const getCaseStatusLabel = (status) => status && status in CASE_STATUS_META
    ? CASE_STATUS_META[status].label
    : "";
//# sourceMappingURL=caseStatues.js.map